export default __webpack_public_path__ + "static/media/video_placeholder_md.ceaac755.svg";